import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { SistemaSalud } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_SISTEMA_SALUD = '/sistema-salud';

@Injectable({
  providedIn: 'root',
})
export class SistemaSaludService {
  private readonly API_URL_SISTEMA_SALUD = API_URL + ENDPOINT_SISTEMA_SALUD;
  private http = inject(HttpClient);

  listarSistemaSalud(): Observable<SistemaSalud[]> {
    return this.http.get<ResponseWrapper<SistemaSalud[]>>(this.API_URL_SISTEMA_SALUD).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
